"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationService_1 = require("../ValidationService");
var ValidationErrorMessageBuilder_1 = require("../ValidationErrorMessageBuilder");
function getErrorMessages() {
    return ValidationErrorMessageBuilder_1.ValidationErrorMessageBuilder.create()
        .map('bankAccountNumber', 'Kontonumret är inte rätt ifyllt. Kolla att det stämmer.')
        .mapCombined('required', 'bankAccountNumber', 'Fyll i ett kontonummer.')
        .map('bankgiro', 'Skriv bankgironumret med siffror och bindestreck.')
        .mapCombined('required', 'bankgiro', 'Fyll i bankgironumret.')
        .map('clearingNumber', 'Clearingnumret är inte rätt ifyllt. Kolla att det stämmer.')
        .mapCombined('required', 'clearingNumber', 'Clearingnummer är tomt.')
        .map('date', 'Du har skrivit ett felaktigt datum.')
        .mapCombined('required', 'date', 'Välj ett datum.')
        .map('dateFormat', 'Skriv datumet med åtta siffror.')
        .map('decimal', 'Fyll i ett värde med korrekt antal decimaler.')
        .map('greaterThan', 'Fyll i en högre siffra.')
        .map('integer', 'Fyll i siffror utan decimal.')
        .mapCombined('required', 'integer', 'Fyll i en siffra.')
        .map('lessThan', 'Du har fyllt i en för hög siffra.')
        .map('minDate', 'Du har valt ett datum som ligger för långt bak i tiden.')
        .mapCombined('minDate', 'date', 'Du har valt ett datum som ligger för långt bak i tiden.')
        .map('maxDate', 'Du har valt ett datum som ligger för långt fram i tiden.')
        .mapCombined('maxDate', 'date', 'Du har valt ett datum som ligger för långt fram i tiden.')
        .map('maxValue', 'Du har fyllt i en för hög siffra.')
        .map('minValue', 'Fyll i en högre siffra.')
        .map('number', 'Du har fyllt i ett ogiltigt tecken. Fyll i siffror.')
        .mapCombined('required', 'number', 'Fyll i en siffra.')
        .mapCombined('minValue', 'number', 'Fyll i en högre siffra.')
        .mapCombined('maxValue', 'number', 'Du har fyllt i en för hög siffra.')
        .map('organisationsnummer', 'Fyll i organisationsnumret med tio siffor, till exempel 999999-9999.')
        .mapCombined('required', 'organisationsnummer', 'Fyll i ett organisationsnummer med tio siffror, till exempel 999999-9999.')
        .map('percent', 'Fyll i procent med en siffra.')
        .mapCombined('integer', 'percent', 'Fyll i procent utan decimal')
        .mapCombined('required', 'percent', 'Fyll i en siffra.')
        .mapCombined('minValue', 'percent', 'Fyll i en högre siffra.')
        .mapCombined('maxValue', 'percent', 'Fyll i en lägre siffra.')
        .map('personnummer', 'Skriv personnumret med tolv siffror.')
        .mapCombined('required', 'personnummer', 'Fyll i ett personnummer.')
        .map('postalCode', 'Fyll i postnumret med fem siffror.')
        .mapCombined('required', 'postalCode', 'Fyll i ett postnummer.')
        .map('phoneNumber', 'Telefonnumret är inte rätt ifyllt')
        .mapCombined('required', 'phoneNumber', 'Kontrollera att telefonnumret stämmer.')
        .map('plusgiro', 'Skriv plusgironumret med siffror och bindestreck.')
        .mapCombined('required', 'plusgiro', 'Fyll i plusgironumret.')
        .map('required', 'Fyll i text.')
        .map('whitelist', 'Fältet innehåller otillåtna tecken. Exempel på ogiltiga tecken är /, % , och "')
        .build();
}
exports.getErrorMessages = getErrorMessages;
/*
 * If your domain doesn't have specific error messages for validators
 * then this set of error messages can be applied:
 *
 * import { applyValidationMessages } from '@fkui/logic';
 * applyValidationMessages();
 */
function applyValidationMessages() {
    ValidationService_1.ValidationService.addValidationErrorMessages(getErrorMessages());
}
exports.applyValidationMessages = applyValidationMessages;
//# sourceMappingURL=ValidationTranslations.js.map